// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProgressBar.module.scss  */
.ProgressBar-module-Root_17U {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%; }
  .ProgressBar-module-Root_17U::before {
    position: absolute;
    top: 50%;
    width: 100%;
    height: 2px;
    content: '';
    background-color: #dee1eb;
    transform: translateY(-50%); }

.ProgressBar-module-Step_2U_ {
  position: relative;
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  border: 2px solid #fff;
  border-radius: 50%;
  background-color: #dee1eb; }
  .ProgressBar-module-Step_2U_.ProgressBar-module-current_2XT {
    background-color: #8168f0;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1); }

.ProgressBar-module-Indicator_1pK {
  position: absolute;
  top: 50%;
  width: 0;
  height: 2px;
  background-color: #8168f0;
  transition: width 200ms ease-out;
  transform: translateY(-50%); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ProgressBar/ProgressBar.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,WAAW,EAAE;EACb;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,2BAA2B,EAAE;;AAEjC;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB,EAAE;EAC3B;IACE,yBAAyB;IACzB,wCAAwC,EAAE;;AAE9C;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B,EAAE","sourcesContent":["/*  imported from ProgressBar.module.scss  */\n.ProgressBar-module-Root_17U {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  width: 100%; }\n  .ProgressBar-module-Root_17U::before {\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    height: 2px;\n    content: '';\n    background-color: #dee1eb;\n    transform: translateY(-50%); }\n\n.ProgressBar-module-Step_2U_ {\n  position: relative;\n  display: block;\n  width: 0.5rem;\n  height: 0.5rem;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  background-color: #dee1eb; }\n  .ProgressBar-module-Step_2U_.ProgressBar-module-current_2XT {\n    background-color: #8168f0;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1); }\n\n.ProgressBar-module-Indicator_1pK {\n  position: absolute;\n  top: 50%;\n  width: 0;\n  height: 2px;\n  background-color: #8168f0;\n  transition: width 200ms ease-out;\n  transform: translateY(-50%); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
